import {
    AcceptTotalDTSMEPackagePaidAmountInReconciliation,
    GetDTSMEMarketPlaceCompanyInformationList,
    GetDTSMEMarketPlaceCompanyInformationById,
    AddEditDTSMEMarketPlaceCompanyInformation,
    GetALLMarketPlaceCompanyInformationList,
    GetAllDropdownsForDTSME,
    DownloadSheetForDTSMEPurchaseReport,
    GetDTSMEPurchaseRecordList
    

} from "../ApiEndPoints";
import {
    axiosGetAuthorizeMultiParams,
    axiosGetAuthorize,
    axiosPostAuthorize,
    axiosPostFileAuthorizeblob,
} from "../AxiosRequests";

export default class DtsmeServices {
    async acceptTotalDTSMEPackagePaidAmountInReconciliation(request) {
        return axiosGetAuthorizeMultiParams(AcceptTotalDTSMEPackagePaidAmountInReconciliation, request);
    }
    async getALLMarketPlaceCompanyInformationList(request) {
        return axiosGetAuthorize(GetALLMarketPlaceCompanyInformationList, request);
    }
    async getDTSMEMarketPlaceCompanyInformationList(request) {
        return axiosPostAuthorize(GetDTSMEMarketPlaceCompanyInformationList, request);
    }
    async getDTSMEMarketPlaceCompanyInformationById(request) {
        return axiosGetAuthorize(GetDTSMEMarketPlaceCompanyInformationById, request);
    }
    async getAllDropdownsForDTSME(request) {
        return axiosGetAuthorize(GetAllDropdownsForDTSME, request);
    }
    async addEditDTSMEMarketPlaceCompanyInformation(request) {
        return axiosPostAuthorize(AddEditDTSMEMarketPlaceCompanyInformation, request);
    }
    async downloadSheetForDTSMEPurchaseReport(request) {
        return axiosPostFileAuthorizeblob(DownloadSheetForDTSMEPurchaseReport, request);
    }
    async getDTSMEPurchaseRecordList(request) {
        return axiosPostAuthorize(GetDTSMEPurchaseRecordList, request);
    }
}
